import TagManager from 'react-gtm-module';

export const createLayerTagManager = (dataLayer, dataLayerName) => {
  TagManager.dataLayer({
    dataLayer,
    dataLayerName,
  });
};
